// extracted by mini-css-extract-plugin
export default {"HeaderImage":"X6Zn6Y1YuL_3N5vapeMo"};